import React, { useCallback, useEffect, useState } from 'react'
import AiImageGenerationTabTitle from '../../../components/Title'
import { CHARACTERS_ERROR_STATE } from 'common-components/CharacterCountIndicator/utils'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'
import { IMG_PROMPT_HEIGHT, IMG_PROMPT_MAX_LENGTH } from './consts'
import { useSelector } from 'react-redux'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { dispatch } from 'store'
import debounce from 'lodash.debounce'

const AiImageGenerationPrompt: React.FC = () => {
  const prompt = useSelector(aiImageSelectors.prompt)
  const [currentPrompt, setCurrentPrompt] = useState(prompt)

  const debounceChange = debounce((textValue: string) => {
    dispatch(aiImageThunks.setPrompt(textValue))
  }, 400)

  const handleChange = useCallback((value: string) => {
    setCurrentPrompt(value)
    debounceChange(value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setCurrentPrompt(prompt)
  }, [prompt])

  const currentTextLength = currentPrompt.length
  const isErrorState = currentTextLength >= IMG_PROMPT_MAX_LENGTH
  const textWarningState = isErrorState ? CHARACTERS_ERROR_STATE : undefined

  return (
    <Styled.AiImageGenerationPrompt>
      <AiImageGenerationTabTitle>
        {translate(T.IMAGE_PROMPT_TITLE)}
      </AiImageGenerationTabTitle>
      <Styled.AiImageGenerationPromptTextArea
        value={currentPrompt}
        onChange={handleChange}
        placeholder={translate(T.PROMPT_PLACEHOLDER)}
        minHeight={105}
        maxHeight={IMG_PROMPT_HEIGHT}
        maxLength={IMG_PROMPT_MAX_LENGTH}
        hasErrorOutline={isErrorState}
      />
      <Styled.CharacterCountIndicatorWrapper
        currentTextLength={currentTextLength}
        maxCount={IMG_PROMPT_MAX_LENGTH}
        textWarningState={textWarningState}
      />
    </Styled.AiImageGenerationPrompt>
  )
}

export default AiImageGenerationPrompt
